import { Mark, mergeAttributes } from '@tiptap/core';

export const DiffInsert = Mark.create({
  name: 'diffInsert',

  parseHTML() {
    return [{ tag: 'ins' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['ins', mergeAttributes(HTMLAttributes), 0];
  },
});
